export default "__VITE_ASSET__BtsMbX9B__"